export const patientCardStyles = {
  root: "my-2 gap-0 overflow-hidden rounded-2xl border-border py-0 shadow-sm",
  nameRow: "flex items-center gap-3 px-4 pb-3 pt-4",
  avatar: "h-10 w-10 bg-accent",
  avatarFallback: "text-sm font-bold text-primary",
  name: "text-sm font-semibold leading-tight text-strong",
  mrnLine: "mt-0.5 text-xs text-subtle",
  fields: "grid grid-cols-2 gap-x-4 gap-y-2 border-t border-border px-4 py-3",
  fieldLabel: "text-2xs font-medium uppercase tracking-wide text-subtle",
  fieldValue: "text-sm text-mid",
};
